import React from "react";
import emt_logo from "../../../Assets/Logo/HeadtlerLogo.png";
import "./Profile.scss";
import UserInfo from "./ProfileComponents/UserInfo";
import CancelButton from "./ProfileComponents/CancelButton";
import { GetUserInfo } from "../../../CommonFunction/GetUserInfo";
function Profile(props) {
  let loginData = GetUserInfo();

  return (
    <>
      <div className="cancelContainer">
        <CancelButton toggle={props.toggle} />
      </div>
      {loginData && loginData.userDetails ? (
        <UserInfo
          src={emt_logo}
          orgnization={loginData?.userDetails[0]?.CompanyCode?.CompanyName}
          username={loginData && loginData?.userDetails[0]?.UserName}
          accesscode={loginData && loginData?.CompanyCode}
        />
      ) : (
        ""
      )}
    </>
  );
}

export default Profile;
